import React__default from 'react';
import { CloseOutlined } from '@teko/ds-icon';
import styled from '@emotion/styled';
import { pixelParse } from '../../helpers/utils.es.js';

const ModalCloseIcon = ({
  onHide,
  closeIcon = /* @__PURE__ */ React__default.createElement(CloseOutlined, {
    size: 32,
    color: "#000"
  }),
  className
}) => {
  return /* @__PURE__ */ React__default.createElement(CloseIconWrapper, {
    className,
    onClick: onHide
  }, closeIcon);
};
const CloseIconWrapper = styled.div(({ size }) => `
  z-index: 1060;
  position: absolute;
  left: 100%;
  transform: translateX(-100%);
  min-width: ${pixelParse(size || "") || "56px"};
  min-height: ${pixelParse(size || "") || "56px"};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`);

export { ModalCloseIcon };
